/* eslint-disable boundaries/no-unknown-files -- main.tsx is an entry point file that should be recognized as 'app' type, but eslint-plugin-boundaries pattern matching doesn't work reliably for this file */
import React from "react";
import { createRoot } from "react-dom/client";

import { ProgressProvider, NotificationProvider, RemindersProvider } from "@/shared/contexts";

import "./index.css";
import { App } from "./App";

// ✅ Standard-Scrolling mit Webkit-Scrollbars

/**
 * Entry-Point für die TracQ-Frontend-App.
 * Bindet React, StrictMode, globale Styles und die Context-Provider ein.
 */
const rootElement = document.querySelector("#root");

if (!rootElement) {
  throw new Error(
    "❌ Root-Element (#root) nicht gefunden. Stelle sicher, dass es in deiner index.html existiert.",
  );
}

createRoot(rootElement).render(
  <React.StrictMode>
    <ProgressProvider>
      <NotificationProvider>
        <RemindersProvider>
          <App />
        </RemindersProvider>
      </NotificationProvider>
    </ProgressProvider>
  </React.StrictMode>,
);
/* eslint-enable boundaries/no-unknown-files */
